export default __webpack_public_path__ + "static/media/main-banner-m-1.0a171491.svg";